module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"current":"Current Plan","upgrade":"Select","downgrade":"Select","renewCurrentPlan":"Renew","next":"Next plan","from":"from","free":"Free","plan":"Plan","price":"Price per month","try":"Try","ok":"Ok","cancel":"Cancel","dialogAddPaymentMethodTitle":"You need to add a payment method","unlimited":"Unlimited"}}')
  delete Component.options._Ctor
}
